const itdr = {
  en: {
    translation: {
      page_description: "ITDR is a category of incidents that may have affected your organization",
      date: "Date",
      platform: "Platform",
      severity: "Severity",
      status: "Status",
      subject: "Subject",
      details: "Details",
    },
  },
  it: {
    translation: {
      page_description:
        "Gli ITDR sono una categoria di incidenti che potrebbero aver avuto conseguenze sulla tua organizzazione",
      date: "Data",
      platform: "Piattaforma",
      severity: "Rischio",
      status: "Stato",
      subject: "Oggetto",
      details: "Dettagli",
    },
  },
};

export default itdr;
